import { render, staticRenderFns } from "./CreateTrackingCategoryAmountPopup.vue?vue&type=template&id=38e1e828&"
import script from "./CreateTrackingCategoryAmountPopup.vue?vue&type=script&lang=js&"
export * from "./CreateTrackingCategoryAmountPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateTrackingCategoryAmountPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports